module.exports = __webpack_public_path__ + "ffb7d1004f46029a3069c0feb32e1317.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/main/history.jpg
// module id = 166
// module chunks = 0